import React from 'react'
import PropTypes from 'prop-types'
import './ProjectReturnLink.scss'
import { Icon } from 'react-fa'
import LocalizedString from '../LocalizedString'

const ProjectReturnLink = (props) => {
  return (
    (props.url)
      ? (
        <a href={props.url} className={`project-return-link ${props.className}`}>
          <Icon name='chevron-left' />
          <LocalizedString resourceKey='taskBoards.Label_GoToTaskList' />
        </a>
      )
      : <span />
  )
}

ProjectReturnLink.propTypes = {
  url: PropTypes.string.isRequired,
  className: PropTypes.string
}

export default ProjectReturnLink



// WEBPACK FOOTER //
// ./src/components/ProjectReturnLink/ProjectReturnLink.js